export const API_SUCCESS = 'API_SUCCESS';

export const DONE_STATISTICS_LOADING = "DONE_STATISTICS_LOADING";
export const DONE_STATISTICS_LOADED = "DONE_STATISTICS_LOADED";

export const PURCHASE_ORDERS_STATISTICS_LOADING = "PURCHASE_ORDERS_STATISTICS_LOADING";
export const PURCHASE_ORDERS_STATISTICS_LOADED = "PURCHASE_ORDERS_STATISTICS_LOADED";

export const VEHICLES_GARAGES_STATISTICS_LOADING = "VEHICLES_GARAGES_STATISTICS_LOADING";
export const VEHICLES_GARAGES_STATISTICS_LOADED = "VEHICLES_GARAGES_STATISTICS_LOADED";